function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 16
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  opacity: 0.5
},
/*#__PURE__*/
React.createElement("path", {
  d: "M15.2724 25.3009C15.4653 25.4938 15.727 25.6022 15.9998 25.6022C16.2726 25.6022 16.5342 25.4938 16.7272 25.3009C16.9201 25.108 17.0285 24.8463 17.0285 24.5735V7.42906C17.0285 7.15624 16.9201 6.89459 16.7272 6.70168C16.5342 6.50877 16.2726 6.40039 15.9998 6.40039C15.727 6.40039 15.4653 6.50877 15.2724 6.70168C15.0795 6.89459 14.9711 7.15624 14.9711 7.42906V24.5735C14.9711 24.8463 15.0795 25.108 15.2724 25.3009Z",
  fill: "white"
}),
/*#__PURE__*/
React.createElement("path", {
  d: "M10.4423 20.6742L6.84748 17.0793C6.56095 16.7923 6.40002 16.4034 6.40002 15.9978C6.40002 15.5923 6.56095 15.2033 6.84748 14.9164L10.4423 11.3215C10.6362 11.134 10.896 11.0302 11.1658 11.0325C11.4355 11.0347 11.6935 11.1427 11.8843 11.3334C12.0751 11.524 12.1835 11.782 12.1859 12.0517C12.1884 12.3214 12.0848 12.5813 11.8975 12.7754L8.67439 16.0013L11.8975 19.223C12.0848 19.4171 12.1884 19.677 12.1859 19.9467C12.1835 20.2165 12.0751 20.4744 11.8843 20.665C11.6935 20.8557 11.4355 20.9637 11.1658 20.966C10.896 20.9682 10.6362 20.8644 10.4423 20.6769V20.6742Z",
  fill: "white"
}),
/*#__PURE__*/
React.createElement("path", {
  d: "M20.1036 20.6742C20.008 20.5787 19.9322 20.4654 19.8805 20.3407C19.8288 20.216 19.8022 20.0823 19.8022 19.9472C19.8022 19.8122 19.8288 19.6785 19.8805 19.5538C19.9322 19.429 20.008 19.3157 20.1036 19.2203L23.3254 16.0013L20.1036 12.7754C19.9163 12.5813 19.8127 12.3214 19.8152 12.0517C19.8177 11.782 19.926 11.524 20.1168 11.3334C20.3076 11.1427 20.5657 11.0347 20.8354 11.0325C21.1051 11.0302 21.3649 11.134 21.5588 11.3215L25.1536 14.9164C25.4395 15.2037 25.6 15.5925 25.6 15.9978C25.6 16.4031 25.4395 16.792 25.1536 17.0793L21.5588 20.6742C21.4633 20.7697 21.3498 20.8456 21.225 20.8973C21.1001 20.949 20.9663 20.9757 20.8312 20.9757C20.696 20.9757 20.5622 20.949 20.4374 20.8973C20.3125 20.8456 20.1991 20.7697 20.1036 20.6742Z",
  fill: "white"
}));

var SvgRange = function SvgRange(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 32,
      height: 32,
      viewBox: "0 0 32 32",
      fill: "none",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2, _ref3)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgRange, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/range.4a5de922.svg";
export { ForwardRef as ReactComponent };